import { LoyaltyPointsInfos } from './LoyaltyPointsInfos';

export default LoyaltyPointsInfos;
